// extracted by mini-css-extract-plugin
module.exports = {"difficultyWrapper":"DifficultyRating_difficultyWrapper__JU_Qi","difficultyMarker":"DifficultyRating_difficultyMarker__sMykn","active":"DifficultyRating_active__fHoiy"};